import React, {useMemo, useRef, useState} from 'react';
import {Editor} from "@tinymce/tinymce-react";
import dynamic from "next/dynamic";

export const RichEditor = (props: { data: string, setData: any, height: number, placeholder?: string }) => {

    const editor = useRef(null);

    const config = useMemo( () => {
        return  {
            readonly: false,
            placeholder: props.placeholder || 'Start typing...'
        }
    }, [props.placeholder]);

    const JoditEditor = dynamic(
        () => import('jodit-react'),
        { ssr: false}
    )

    return (
        <>
            <JoditEditor
                ref={editor}
                value={props.data}
                config={config}
                onBlur={newContent => props.setData(newContent)} // preferred to use only this option to update the content for performance reasons
                onChange={newContent => {}}
            />
        </>
    );
};
